exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dashboard-chart-wrap[data-v-51950298]{height:320px;position:relative}.dashboard-chart-wrap[data-v-51950298] >div{height:100%!important}", ""]);

// exports
